define('viewmodels/Weightings_Thresholds/SanctionsControlsWeightings',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system'], function (ko, router, appsecurity, navigation, app, logger, system) {
    var title = 'AMLControlsWeightings';
    var checkWeighting = 0;

    var SCWViewModel = {
        setTriggerAttach: true,
        activate: activate,
        title: title,
        attached: attached,
        detached: detached,
        appsecurity: appsecurity,
        ControlAreaList: ko.observableArray(),
        BusinessUnitsList: ko.observableArray(),
        BusinessLevelList: ko.observableArray(),
        WeightingsList: ko.observableArray(),
        ClickedLevelDetailId: ko.observable(),
        ClickedLevelDetailName: ko.observable(),
        saveWeightingsAMLControls: saveWeightingsAMLControls,
        saveValues: saveValues,
        saveAMLLevelControlsWeightings: saveAMLLevelControlsWeightings,
        buildsaveConBULWeightingsList: buildsaveConBULWeightingsList,
        copyDataAMLControls: copyDataAMLControls,
        //ShowToolTip: ShowToolTip,
        RiskLevelTabClick: RiskLevelTabClick,
        GetTotalWeightingsOverall: GetTotalWeightingsOverall,
        BusinessLevelDetailsList: ko.observableArray(),
        Overalllowestlevel: ko.observable(),
        ClickedType: ko.observable(),
        GetRiskLevelSubtabs: GetRiskLevelSubtabs,
        BULWeightingsListSave: ko.observableArray(),
        copyOverallData: copyOverallData,
        countEntry: ko.observable(0),
        ErrorStatus: ko.observable(0),
        PrevLevelDetailId: ko.observable('0'),
        PrevLevelDetailIdNumber: ko.observable(),
        ClickedLevelDetailIdNumber: ko.observable(),
        InputChange: InputChange,
        InputChangeEvent: ko.observable(false),
        CopyDataButtonClicked: ko.observable(false),
        SaveButtonClick: ko.observable(false),
        ClickedLevelDetailIdDup: ko.observable()
    };

    return SCWViewModel;

    var GetAllControlAreasAjax = {};
    var GetWeightingsAjax = {};
    var SaveWeightingsAjax = {};

    function activate() {
        try {

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    };

    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(2)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    };

    function attached() {
        try {
            SCWViewModel.countEntry(0);
            SCWViewModel.appsecurity.GetCurrentYearOfAssessment().then(function () {
                SCWViewModel.appsecurity.getYearOfAssessmentDetails().then(function () {
                    if (SCWViewModel.appsecurity.isConfigurationFreeze() == 1) {
                        SCWViewModel.appsecurity.WriteAccess(false);

                        GetRiskLevelDetails();
                    }
                    else {

                        GetRiskLevelDetails();
                    }
                })
            })
            $($(document.getElementsByClassName('list-group-item')).get(2)).addClass('active');
            $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(5)).addClass('active');
            //GetRiskLevelDetails();

            var options = {
                url: "/api/WeightingsThresholds/GetAllBusinessUnits",
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            };
            getAllBusinessUnits(options);
            if (SCWViewModel.BusinessUnitsList().length != 0) {
                GetAllControlAreasAjax = {
                    url: "/api/ControlArea/GetAllControlArea?Type=SANC",
                    type: "GET",
                    async: false,
                    headers: appsecurity.getSecurityHeaders()
                };
                GetAllControlAreas(GetAllControlAreasAjax);
            } else {
                app.showMessage("Business unit configurations are not in place.", "Error", ["OK"]);
                $("#NobusinessUnitserrorSANC").show();
                $("#RaTab").hide();
            }
            $(document.body).on('blur', '#txt_weightingAMLControls', function (event) {
                saveValues(event);
            });
            var url = window.location.pathname;
            var filename = url.substring(url.lastIndexOf('/') + 1);
            if (filename == "SanctionsControlsWeightings") {
                $(document).on('change', 'input', function (e) {
                    GetTotalWeightings();
                    GetTotalWeightingsOverall();
                });
            }
            $('body').on('keydown', 'input', function (e) {
                var url = window.location.pathname;
                var filename = url.substring(url.lastIndexOf('/') + 1);
                if (e.which == 9 && filename == "SanctionsControlsWeightings") {

                    var controlid;
                    var id = $(this).attr('id');
                    if (id.substring(0, 19) == "txt_BULweightingCon") {
                        controlid = id.substring(0, 19);
                        var rows = SCWViewModel.ControlAreaList().length;
                        var columnsamlcontrol = SCWViewModel.BusinessLevelDetailsList().length;
                        var result = id.substring(19, id.lastIndexOf("_"));
                        var columnandrownuo = result;

                        var rowno = Number(result.substring(0, columnandrownuo.indexOf('_')));
                        var columnno = Number(result.substring(result.indexOf('_') + 1, result.length));
                    }
                    else {
                        var rows = SCWViewModel.ControlAreaList().length;
                        var columnsamlcontrol = SCWViewModel.BusinessUnitsList().length;
                        var result = id.substring(24, id.length);
                        var columnandrownuo = result.lastIndexOf("_");
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.length));
                    }
                    if (columnsamlcontrol == columnno | columnandrownuo == -1 | isNaN(rowno)) {
                        //do nothing to make tab work as per its functionality
                    }
                    else {
                        rowno = rowno + 1;
                        if (rowno == rows) {
                            rowno = 0;
                            columnno = columnno + 1;
                        }
                        for (var i = columnno; i <= columnsamlcontrol; i++) {

                            if (controlid == "txt_BULweightingCon") {
                                // e.preventDefault();
                                var tobefocusedid = "txt_BULweightingCon" + rowno + "_" + columnno + "_" + SCWViewModel.ClickedLevelDetailId();
                                //$("#" + tobefocusedid).focus();
                                //$("#" + tobefocusedid).select()
                            }
                            else {

                                // e.preventDefault();
                                var tobefocusedid = "txt_weightingAMLControls" + rowno + "_" + columnno
                            }
                            if ($("#" + tobefocusedid).prop('disabled')) {
                                columnno = columnno + 1;
                            }
                            else {
                                break;
                            }

                        }
                        if (columnsamlcontrol == columnno | columnandrownuo == -1 | isNaN(rowno)) {
                            //do nothing to make tab work as per its functionality
                        }
                        else if (controlid == "txt_BULweightingCon") {
                            var tobefocusedid = "txt_BULweightingCon" + rowno + "_" + columnno + "_" + SCWViewModel.ClickedLevelDetailId();
                            e.preventDefault();
                            $("#" + tobefocusedid).focus();
                            $("#" + tobefocusedid).select()
                        }
                        else {
                            var tobefocusedid = "txt_weightingAMLControls" + rowno + "_" + columnno
                            e.preventDefault();
                            $("#" + tobefocusedid).focus();
                            $("#" + tobefocusedid).select()
                        }

                    }

                }
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    //function ShowToolTip(data, event) {
    //    try {
    //        //$(event.currentTarget).tooltip('show');
    //    }
    //    catch (e) {
    //        var msg = 'Exception: ' + e + ' | Source: ShowToolTip() method in SanctionsControlsWeightings.js';
    //        logger.logMessage(msg);
    //    }
    //}

    function RiskLevelTabClick(data) {
        try {
            //var txt = "#div-name-1234-characteristic:561613213213";
            //var numb = txt.match(/\d/g);
            //numb = numb.join("");
            //alert(numb);
            $("#lblErrorAMLControls").hide();
            $('#loadingMainControlsDiv_SANC').show();
            $('#RiskAreaTabDiv').hide();
            var PrevLevelDetailId = SCWViewModel.PrevLevelDetailId();
            SCWViewModel.PrevLevelDetailId();
            SCWViewModel.PrevLevelDetailIdNumber(PrevLevelDetailId.match(/\d/g).join(""));

            if (SCWViewModel.appsecurity.WriteAccess() == false || SCWViewModel.appsecurity.WriteAccess() == "false") {
                SCWViewModel.countEntry(0);
            }
            if (SCWViewModel.countEntry() == 0) {
                SCWViewModel.countEntry(1);
                SCWViewModel.ClickedLevelDetailId(data.Bulevel() + 'OVERALL');
                SCWViewModel.ClickedLevelDetailName(data.BlName());
                if (data.Bulevel() == SCWViewModel.Overalllowestlevel()) {
                    SCWViewModel.ClickedType("LOWEST");
                    GetCULevelWeightings();
                }
                else {
                    SCWViewModel.ClickedType("");
                    GetRiskLevelSubtabs(data.Bulevel());
                    GetCULevelWeightings();
                }
            }

            else if ((SCWViewModel.InputChangeEvent() || SCWViewModel.CopyDataButtonClicked()) && SCWViewModel.SaveButtonClick() == false) {
                SCWViewModel.InputChangeEvent(false);
                SCWViewModel.CopyDataButtonClicked(false);
                app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                .then(function (option) {
                    SCWViewModel.ClickedLevelDetailIdNumber(SCWViewModel.ClickedLevelDetailId().match(/\d/g));
                    if (option == "Save") {
                        if (SCWViewModel.PrevLevelDetailId() == SCWViewModel.Overalllowestlevel() + 'OVERALL') {
                            SCWViewModel.ClickedType("LOWEST");
                            $('#btnSANCSave').click();
                        }
                        else {
                            $('#btnSANCSave-' + SCWViewModel.PrevLevelDetailId()).click();
                        }
                        //SCWViewModel.countEntry(0);
                        if (SCWViewModel.ErrorStatus() == 1) {
                            SCWViewModel.ErrorStatus(0);
                            $('#' + SCWViewModel.PrevLevelDetailIdNumber()).addClass('ui-tabs-active ui-state-active');
                            $('#' + data.Bulevel()).removeClass('ui-tabs-active ui-state-active');
                        }
                        else {
                            SCWViewModel.SaveButtonClick(false);
                            SCWViewModel.countEntry(0);
                            $('#' + SCWViewModel.PrevLevelDetailIdNumber()).removeClass('ui-tabs-active ui-state-active');
                            $('#' + data.Bulevel()).addClass('ui-tabs-active ui-state-active');
                            RiskLevelTabClick(data);
                        }
                    }
                    else {
                        $("#lblErrorAMLControls").hide();

                        SCWViewModel.countEntry(1);
                        //SCWViewModel.ErrorStatus(1);
                        $('#' + SCWViewModel.PrevLevelDetailIdNumber()).removeClass('ui-tabs-active ui-state-active');
                        $('#' + data.Bulevel()).addClass('ui-tabs-active ui-state-active');
                        SCWViewModel.ClickedLevelDetailId(data.Bulevel() + 'OVERALL');
                        SCWViewModel.ClickedLevelDetailName(data.BlName());
                        if (data.Bulevel() == SCWViewModel.Overalllowestlevel()) {
                            SCWViewModel.ClickedType("LOWEST");
                            GetCULevelWeightings();
                        }
                        else {
                            SCWViewModel.ClickedType("");
                            GetRiskLevelSubtabs(data.Bulevel());
                            GetCULevelWeightings();
                        }
                    }
                })

            }
            else {
                SCWViewModel.InputChangeEvent(false);
                SCWViewModel.CopyDataButtonClicked(false);
                SCWViewModel.SaveButtonClick(false);
                SCWViewModel.countEntry(0);
                $('#' + SCWViewModel.PrevLevelDetailIdNumber()).removeClass('ui-tabs-active ui-state-active');
                $('#' + data.Bulevel()).addClass('ui-tabs-active ui-state-active');
                RiskLevelTabClick(data, event);
            }
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskLevelTabClick() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function InputChange() {
        SCWViewModel.InputChangeEvent(true);
    }

    function GetRiskLevelDetails() {
        try {
            $.ajax({
                url: "/api/WeightingsThresholds/getAllBusinessUnitLevels",
                data: { "type": "SANC", "Page_Type": "W" },
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetRiskLevelDetails() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);

        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult.length > 0) {
                    var MappedBUModelList = $.map(jsonResult, function (result) {
                        return new BusinessLevelModel(result);
                    });

                    SCWViewModel.BusinessLevelList(MappedBUModelList);
                    GetDerivedBusinessLevel();
                    //var max = SCWViewModel.BusinessLevelList()[0].Bulevel();
                    //for (var i = 0; i < SCWViewModel.BusinessLevelList().length; i++) {
                    //    if (max < SCWViewModel.BusinessLevelList()[i].Bulevel()) {
                    //        max = SCWViewModel.BusinessLevelList()[i].Bulevel();
                    //    }
                    //}
                    //SCWViewModel.Overalllowestlevel(max);
                    $('#RaTab').tabs();
                    $('#RaTab').tabs('refresh');
                    $('#RaTab').tabs({ active: 0 });
                    $($('#RiskAreaUl li').get(0)).trigger('click');
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCWViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskLevelDetails() method in SanctionsControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRiskLevelDetails() method in SanctionsControlsWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetRiskLevelDetails() method in SanctionsControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
    }

    function GetDerivedBusinessLevel() {
        try {
            $.ajax({
                url: "/api/WeightingsThresholds/GetDerivedBusinessLevel",
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetDerivedBusinessLevel() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var max = SCWViewModel.BusinessLevelList()[0].Bulevel();
                    //for (var i = 0; i < SCWViewModel.BusinessLevelList().length; i++) {
                    //    if (SCWViewModel.BusinessLevelList()[i].BlName().toUpperCase() == (jsonResult[0].DerivedLevel).toUpperCase()) {

                    //        max = SCWViewModel.BusinessLevelList()[i].Bulevel();
                    //    }
                    //}
                    SCWViewModel.Overalllowestlevel(max);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetDerivedBusinessLevel() method in SanctionsControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in operation.", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetDerivedBusinessLevel() method in SanctionsControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetDerivedBusinessLevel() method in SanctionsControlsWeightings.js';
                logger.logMessage(msg);
            }
        };
    }


    function GetAllControlAreas(GetAllControlAreasAjax) {
        try {
            $.ajax(GetAllControlAreasAjax)
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllControlAreas() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    var mappedControlAreas = $.map(jsonResult, function (result) {
                        return new ControlAreas(result);
                    });
                    $('#NoControlareasserror').hide();
                    $('#RiskAreaTabDiv').show();
                    SCWViewModel.ControlAreaList(mappedControlAreas);
                }
                else {
                    app.showMessage("Control Areas are not configured.", "Error", ["OK"]);
                    $('#NoControlareasserror').show();
                    $('#RiskAreaTabDiv').hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllControlAreas() method in SanctionsControlsWeightings.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllControlAreas() method in SanctionsControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllControlAreas() method in SanctionsControlsWeightings.js';
                logger.logMessage(msg);
            }
        };
    }
    function GetTotalWeightings() {

        var url = window.location.pathname;
        var filename = url.substring(url.lastIndexOf('/') + 1);

        for (var k = 0; k < SCWViewModel.BusinessUnitsList().length; k++) {
            var sum = parseFloat(0);
            for (var i = 0; i < SCWViewModel.ControlAreaList().length; i++) {

                var x = "#txt_weightingAMLControls" + i + "_" + k;
                sum = parseFloat(sum) + parseFloat($(x).val());
            }
            var colcount = k;
            if (isNaN(sum)) {
                $("#txt_weightingAMLControls" + colcount).val(0);
            }
            else {


                $("#txt_weightingAMLControls" + colcount).val(sum);
            }
            if (sum == 100) {
                $("#txt_weightingAMLControls" + colcount).css('color', '#000000')
                $("#txt_weightingAMLControls" + colcount).css("background-color", "#cccccc")
            } else {
                $("#txt_weightingAMLControls" + colcount).css('color', 'red')


            }
        }

    }
    function GetTotalWeightingsOverall() {
        var url = window.location.pathname;
        var filename = url.substring(url.lastIndexOf('/') + 1);

        for (var k = 0; k < SCWViewModel.BusinessLevelDetailsList().length; k++) {
            var sum = parseFloat(0);
            for (var i = 0; i < SCWViewModel.ControlAreaList().length; i++) {

                var x = "#txt_BULweightingCon" + i + "_" + k + "_" + SCWViewModel.ClickedLevelDetailId();
                sum = parseFloat(sum) + parseFloat($(x).val());
            }
            var colcount = k;
            if (isNaN(sum)) {
                $("#txt_BULweightingCon" + colcount + SCWViewModel.ClickedLevelDetailId()).val(0);
            }
            else {


                $("#txt_BULweightingCon" + colcount + SCWViewModel.ClickedLevelDetailId()).val(sum);
            }
            if (sum == 100) {
                $("#txt_BULweightingCon" + colcount + SCWViewModel.ClickedLevelDetailId()).css('color', '#000000')
                $("#txt_BULweightingCon" + colcount + SCWViewModel.ClickedLevelDetailId()).css("background-color", "#cccccc")
            } else {
                $("#txt_BULweightingCon" + colcount + SCWViewModel.ClickedLevelDetailId()).css('color', 'red')


            }
        }
    }
    function GetCULevelWeightings() {
        try {
            SCWViewModel.PrevLevelDetailId(SCWViewModel.ClickedLevelDetailId());
            if (SCWViewModel.ClickedType().toUpperCase() == "LOWEST") {
                SCWViewModel.ClickedLevelDetailIdDup(SCWViewModel.ClickedLevelDetailId());
                SCWViewModel.ClickedLevelDetailId("LLEVEL");
            }
            $.ajax({
                url: "/api/WeightingsThresholds/GetCULevelWeightings",
                data: { "RiskAreaType": "SANC", "DeUid": SCWViewModel.ClickedLevelDetailId() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetBUlevelWeightings() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (SCWViewModel.ClickedType().toUpperCase() == "LOWEST") {
                    SCWViewModel.ClickedLevelDetailId(SCWViewModel.ClickedLevelDetailIdDup());
                }
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    var mappedWeightings = $.map(jsonResult, function (result) {
                        return new WeightingModel(result);
                    });
                    if (SCWViewModel.ClickedType() == "LOWEST") {
                        checkWeighting = 1;
                        SCWViewModel.WeightingsList(mappedWeightings);
                        WeightingsTable(checkWeighting);
                    }
                    else {
                        checkBULevelWeighting = 1;
                        SCWViewModel.WeightingsList(mappedWeightings);

                        CULevelWeightingsTable(checkBULevelWeighting);
                    }
                    // GetTotalWeightingsBUL();
                }
                else {
                    if (SCWViewModel.ClickedType() == "LOWEST") {
                        checkBULevelWeighting = 0;
                        WeightingsTable(checkBULevelWeighting);
                    }
                    else {
                        checkBULevelWeighting = 0;
                        CULevelWeightingsTable(checkBULevelWeighting);
                    }

                    //  GetTotalWeightingsBUL();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetBUlevelWeightings() method in SanctionsControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetBUlevelWeightings() method in SanctionsControlsWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetBUlevelWeightings() method in SanctionsControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
    }
    function getAllBusinessUnits(options) {
        try {
            $.ajax(options)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in getAllBusinessUnits() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResultObj, status) {
            try {
                var mappedBusinessUnits = $.map(jsonResultObj, function (result) {
                    return new BusinessUnits(result);
                });
                SCWViewModel.BusinessUnitsList(mappedBusinessUnits);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in getAllBusinessUnits() method in SanctionsControlsWeightings.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAllBusinessUnits() method in SanctionsControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in SanctionsControlsWeightings.js';
                logger.logMessage(msg);
            }
        };

    };
    function GetRiskLevelSubtabs(LevelID) {
        try {
            $.ajax({
                url: "/api/WeightingsThresholds/getBusinessUnitLevelDetails",
                data: { "levelid": LevelID },
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);



        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetRiskLevelDetails() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult.length != 0) {
                    var mappedBULevelsList = $.map(jsonResult, function (result) {
                        return new BusinessLevelDetail(result);
                    });
                    SCWViewModel.BusinessLevelDetailsList(mappedBULevelsList);
                }
                    else {
                        SCWViewModel.BusinessLevelDetailsList([]);
                    }
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SCWViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskLevelDetails() method in SanctionsControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRiskLevelDetails() method in SanctionsControlsWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetRiskLevelDetails() method in SanctionsControlsWeightings.js';
                logger.logMessage(msg);
            }
        }




    }
    function GetWeightings(GetWeightingsAjax) {
        try {
            $.ajax(GetWeightingsAjax)
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetWeightings() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    var mappedWeightings = $.map(jsonResult, function (result) {
                        return new WeightingModel(result);
                    });
                    checkWeighting = 1;
                    SCWViewModel.WeightingsList(mappedWeightings);
                    WeightingsTable(checkWeighting);
                    GetTotalWeightings();
                }
                else {
                    checkWeighting = 0;
                    WeightingsTable(checkWeighting);
                    GetTotalWeightings();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetWeightings() method in SanctionsControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetWeightings() method in SanctionsControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetWeightings() method in SanctionsControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

    }

    function WeightingsTable(checkWeighting) {
        try {
            var code = "";
            var selectedRow, selectedCol;
            var j = SCWViewModel.BusinessUnitsList().length;
            var buHeight;
            var tdHeight;
            for (var i = 0; i < SCWViewModel.BusinessUnitsList().length; i++) {
                colHeight = Math.ceil(SCWViewModel.BusinessUnitsList()[i].BusinessUnit_Name().length / 13)
                if (i == 0) {
                    buHeight = colHeight;

                }
                if (buHeight < colHeight) {
                    buHeight = colHeight;
                }
            }
            tdHeight = 3;
            if (buHeight > 1) {
                tdHeight = tdHeight + ((buHeight - 1) * 1.5);
            }
            bucornerheight = tdHeight / 2;
            var code = '<div class="well well-sm col-xs-12 col-sm-12 col-md-12 col-lg-12">';
            if (SCWViewModel.appsecurity.WriteAccess()) {
                code += '<span id="spnSANCInherent" class="pull-right">' +
                        '<button type="button" class="btn btn-primary btn-sm" id="btnSANCCopy" data-bind="click: $root.copyDataAMLControls" title="Copy values from the first column to all">' +
                            '<i class="fa fa-copy"></i> Copy to All' +
                        '</button>' +
                        '<button type="button" class="btn btn-success btn-sm" id="btnSANCSave" data-bind="click: $root.saveWeightingsAMLControls" title="Click to save">' +
                            '<i class="fa fa-check"></i> Save' +
                        '</button></span>';

            }
            code += '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-1point5  control-label no-padding control-label-key">Business Unit Level Detail : </label>' +
                     '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 fnormal control-label control-label-val">' + SCWViewModel.ClickedLevelDetailName() + '</label>' +
                       '</div><label id="lblErrorAMLControls" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none"></label>';
            //////////////cornercwll staRT CHECK FOR CLOSING DIVS 
            //Corner cell
            code += '<div class="wclscscroll corner-header">' +
                '<table style="width:100%">' +
                      '<tr>' +
                                             '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucornerheight + 'em !important;"><span class="glyphicon glyphicon-arrow-right"></span>Business Unit</th>' +


                     '</tr>' +
                     '<tr>' +
                      '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucornerheight + 'em !important;"><span class="glyphicon glyphicon-arrow-down"></span>Control Areas</th>' +
                      '</tr>' +
                   '</table>' +
              '</div>' +
            //Corner cell end
            //Header Business units
            '<div class="wclscscroll column-headers label-info" style="overflow-y:hidden !important;" id="clscroll-column-headers' + SCWViewModel.ClickedLevelDetailId() + '" style="width:65%;">' +
                '<table>' +
                    '<tr>'
            for (var i = 0 ; i < j; i++) {
                code += '<th style=height:' + tdHeight + 'em !important;" class="site_name long label-info" id="' + SCWViewModel.BusinessUnitsList()[i].BusinessUnit_ID() + '" title="' + SCWViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '">' + SCWViewModel.BusinessUnitsList()[i].BusinessUnit_Name();
            }
            code += '</tr>' +
                       '</table>' +
                      '</div>';
            //Header Business units end
            //Row headers
            code += '<div class="wclscscroll-row row-headers" id="clscroll-row-headers' + SCWViewModel.ClickedLevelDetailId() + '" style="width:100%">' +
                '<table>';
            for (var i = 0; i < SCWViewModel.ControlAreaList().length; i++) {
                var factText = SCWViewModel.ControlAreaList()[i].ControlAreaName();
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;

                code += '<tr><td class="tbl-weightings-cell Weightingsheader" data-toggle="tooltip" style="min-height:42px;height:' + colHeight + 'em !important;"data-placement="right" title="' + SCWViewModel.ControlAreaList()[i].ControlAreaName() + '">';
                code += SCWViewModel.ControlAreaList()[i].ControlAreaName();
                code += '</td></tr>';
            }
            code += '</table></div>';
            //Row headers end
            //Data 
            code += '<div class="wclscscroll table-content" id="clscroll-content' + SCWViewModel.ClickedLevelDetailId() + '" style="width:65%;">' +
'<table id="tblAMLControlsWeightings" ><tbody>';

            var rows = SCWViewModel.ControlAreaList().length;

            for (var i = 0; i < rows; i++) {
                selectedRow = SCWViewModel.ControlAreaList()[i].ControlAreaId();
                var factText = SCWViewModel.ControlAreaList()[i].ControlAreaName();
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;
                selectedRow = SCWViewModel.ControlAreaList()[i].ControlAreaId();
                code += '<tr id="' + SCWViewModel.ControlAreaList()[i].ControlAreaId() + '">';
                for (var k = 0; k < (j) ; k++) {
                    code += '<td id="' + SCWViewModel.BusinessUnitsList()[k].BusinessUnit_ID() + '" style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                    selectedCol = SCWViewModel.BusinessUnitsList()[k].BusinessUnit_ID();
                    if (checkWeighting == 1) {
                        var check_new = true;
                        for (var val = 0; val < SCWViewModel.WeightingsList().length; val++) {
                            if (SCWViewModel.WeightingsList()[val].BuId() == SCWViewModel.BusinessUnitsList()[k].BusinessUnit_ID() && SCWViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                                code += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weightingAMLControls' + i + '_' + k + '" value="0"></input><span class="input-group-addon">%</span>';
                                check_new = false;
                                break;
                            }
                            else if (SCWViewModel.WeightingsList()[val].ControlAreaId() == SCWViewModel.ControlAreaList()[i].ControlAreaId() && SCWViewModel.WeightingsList()[val].BuId() == SCWViewModel.BusinessUnitsList()[k].BusinessUnit_ID()) {
                                code += '<input type="text" class="form-control form-controlWT" id="txt_weightingAMLControls' + i + '_' + k + '" value="' + SCWViewModel.WeightingsList()[val].WeightingValue() + '"></input><span class="input-group-addon">%</span>';
                                check_new = false;
                                break;
                            }
                        }
                        if (check_new) {
                            if (SCWViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                SCWViewModel.WeightingsList().push(newObj);
                                code += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weightingAMLControls' + i + '_' + k + '" value="0"></input><span class="input-group-addon">%</span>';
                            }
                            else {
                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                SCWViewModel.WeightingsList().push(newObj);
                                code += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weightingAMLControls' + i + '_' + k + '" value="0"></input><span class="input-group-addon">%</span>';
                            }
                        }
                    } else {
                        if (SCWViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            SCWViewModel.WeightingsList().push(newObj);
                            code += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weightingAMLControls' + i + '_' + k + '" value="0"></input><span class="input-group-addon">%</span>';
                        }
                        else {
                            //     code1 += '<input type="text" id="txt_fac' + SCWViewModel.ControlAreaList()[i].ControlAreaId() + '_bu' + SCWViewModel.BusinessUnitsList()[k - 1].BusinessUnit_ID() + '" value=""></input><label>%</label>';
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            SCWViewModel.WeightingsList().push(newObj);
                            code += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weightingAMLControls' + i + '_' + k + '" value="0"></input><span class="input-group-addon">%</span>';
                        }
                    }
                    code += '</div></td>';
                    // code1 += '100%';

                    //code1 += '</td>';
                }
                code += '</tr>';
            }


            code += '</tbody></table></div>';
            //data end
            //Total  cell

            code += '<div class="wclscscroll corner-header">' +
                '<table>' +
           '<tr>';

            code += '<td  style="min-height:42px;height:5em !important;" class="tbl-weightings-cell weightingspadding label-info">';
            code += "Total"
            code += '</td>' +

            '</tr>' +

         '</table>' +
    '</div>' +
            //Total cell end  
            //Total Data
            '<div class="wclscscroll-footer column-footer" style="overflow-y: hidden!important;background-color:transparent" id="clscroll-column-footer' + SCWViewModel.ClickedLevelDetailId() + '">' +
                 '<table>' +
                     '<tr>';
            for (l = 0; l < SCWViewModel.BusinessUnitsList().length; l++) {
                code += '<td style="min-height:42px;height:5em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                code += '<input type="text" disabled style="background-color:#cccccc" class="form-control form-controlWT" id="' + 'txt_weightingAMLControls' + l + '"></input><span class="input-group-addon">%</span>';
                code += '</td>';
            }
            code += '</tr>' +
    '</table></div>';
            //Total Dataend

            document.getElementById('divAMLControlsWeightings').innerHTML = '';
            document.getElementById('divAMLControlsWeightings').innerHTML += code;
            //ko.applyBindingsToNode(($('.tbl-weightings-cell headcol')), { event: { mouseover: SCWViewModel.ShowToolTip } }, SCWViewModel);
            //ko.applyBindingsToNode($('#tblAMLControlsWeightings td'), { event: { mouseover: SCWViewModel.ShowToolTip } }, SCWViewModel);
            ko.applyBindingsToNode($('#btnSANCSave'), { click: SCWViewModel.saveWeightingsAMLControls }, SCWViewModel);
            ko.applyBindingsToNode($('#btnSANCCopy'), { click: SCWViewModel.copyDataAMLControls }, SCWViewModel);
            for (var i = 0; i < rows; i++) {
                for (var k = 0; k < (j + 1) ; k++) {

                    ko.applyBindingsToNode($('#txt_weightingAMLControls' + i + '_' + k), { event: { keyup: SCWViewModel.InputChange } }, SCWViewModel);

                }
            }
            $('#divAMLControlsWeightings').show();
            GetTotalWeightings();
            ImplementSecurity();

            $("#clscroll-content" + SCWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-row-headers" + SCWViewModel.ClickedLevelDetailId()).scrollTop($("#clscroll-content" + SCWViewModel.ClickedLevelDetailId()).scrollTop());
                $("#clscroll-column-headers" + SCWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-content" + SCWViewModel.ClickedLevelDetailId()).scrollLeft());
                $("#clscroll-column-footer" + SCWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-content" + SCWViewModel.ClickedLevelDetailId()).scrollLeft());
            });

            $("#clscroll-column-headers" + SCWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-content" + SCWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-column-headers" + SCWViewModel.ClickedLevelDetailId()).scrollLeft());
            });

            $("#clscroll-column-footer" + SCWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-content" + SCWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-column-footer" + SCWViewModel.ClickedLevelDetailId()).scrollLeft());
            });

            $("#clscroll-row-headers" + SCWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-content" + SCWViewModel.ClickedLevelDetailId()).scrollTop($("#clscroll-row-headers" + SCWViewModel.ClickedLevelDetailId()).scrollTop());
            });
            $('#loadingMainControlsDiv_SANC').hide();
            $('#RiskAreaTabDiv').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: WeightingsTable() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    }


    function CULevelWeightingsTable(checkBULevelWeighting) {
        try {
            //see here
            if (SCWViewModel.BusinessLevelDetailsList().length != 0) {
                $('#divAMLControlsWeightings').show();
                $('#divAMLControlsWeightings').removeClass('alert-warning-error');
                var colHeight;
                var buHeight
                var tdHeight;
            for (var i = 0; i < SCWViewModel.BusinessLevelDetailsList().length; i++) {
                colHeight = Math.ceil(SCWViewModel.BusinessLevelDetailsList()[i].DetailName().length / 13)
                if (i == 0) {
                    buHeight = colHeight;

                }
                if (buHeight < colHeight) {
                    buHeight = colHeight;
                }
            }
            tdHeight = 3;
            if (buHeight > 1) {
                tdHeight = tdHeight + ((buHeight - 1) * 1.5);
            }
            var bucornerheight = tdHeight / 2;
            var selectedRow, selectedCol;
            var rows = SCWViewModel.ControlAreaList().length;
            var j = SCWViewModel.BusinessLevelDetailsList().length;
            document.getElementById('divAMLControlsWeightings').innerHTML = "";
            var code = '<div class="well well-sm col-xs-12 col-sm-12 col-md-12 col-lg-12">';
            if (SCWViewModel.appsecurity.WriteAccess()) {
                code += '<span id="spnSANCInherent" class="pull-right">' +
                        '<button type="button" class="btn btn-primary btn-sm" id="btnSANCCopy-' + SCWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.copyOverallData" title="Copy values from the first column to all">' +
                            '<i class="fa fa-copy"></i> Copy to All' +
                        '</button>' +
                        '<button type="button" class="btn btn-success btn-sm" id="btnSANCSave-' + SCWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.saveAMLLevelControlsWeightings" title="Click to save">' +
                            '<i class="fa fa-check"></i> Save' +
                        '</button></span>';
            }
            code += '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-1point5 control-label no-padding control-label-key">Organizational Sub Level Detail : </label>' +
                       '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 fnormal control-label control-label-val">' + SCWViewModel.ClickedLevelDetailName() + '</label></div>' +
            '</div><label id="lblErrorAMLControls-' + SCWViewModel.ClickedLevelDetailId() + '" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none"></label>';
            //Corner cell
            code += '<div class="wclscscroll corner-header">' +
                '<table style="width:100%">' +
                      '<tr>' +
                                             '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucornerheight + 'em !important;"><span class="glyphicon glyphicon-arrow-right"></span>Organizational Sub Level</th>' +


                     '</tr>' +
                     '<tr>' +
                      '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucornerheight + 'em !important;"><span class="glyphicon glyphicon-arrow-down"></span>Control Areas</th>' +
                      '</tr>' +
                   '</table>' +
              '</div>';
            //Corner cell end
            //Header Business units
            code += '<div class="wclscscroll column-headers" style="overflow-y:hidden !important;" id="clscroll-column-headers' + SCWViewModel.ClickedLevelDetailId() + '" style="width:65%;">' +
                '<table>' +
                    '<tr>'
            for (var i = 0 ; i < j; i++) {
                code += '<th class="site_name long label-info" style=height:' + tdHeight + 'em !important;" id="' + SCWViewModel.BusinessLevelDetailsList()[i].DetailId() + '" title="' + SCWViewModel.BusinessLevelDetailsList()[i].DetailName() + '">' + SCWViewModel.BusinessLevelDetailsList()[i].DetailName() + '</th>';
            }
            code += '</tr>' +
                       '</table>' +
                      '</div>';
            //Header Business units end
            //Row headers
            code += '<div class="wclscscroll-row row-headers" id="clscroll-row-headers' + SCWViewModel.ClickedLevelDetailId() + '" style="width:100%">' +
                '<table>';
            for (var i = 0; i < SCWViewModel.ControlAreaList().length; i++) {
                var factText = SCWViewModel.ControlAreaList()[i].ControlAreaName();
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;
                selectedRow = SCWViewModel.ControlAreaList()[i].ControlAreaId();
                code += '<tr><td class="tbl-weightings-cell Weightingsheader" data-toggle="tooltip" style="min-height:42px;height:' + colHeight + 'em !important;"data-placement="right" title="' + SCWViewModel.ControlAreaList()[i].ControlAreaName() + '">';
                code += SCWViewModel.ControlAreaList()[i].ControlAreaName();
                code += '</td></tr>';
            }
            code += '</table></div>';
            //Row headers end
            //Data 
            code += '<div class="wclscscroll table-content" id="clscroll-content' + SCWViewModel.ClickedLevelDetailId() + '" style="width:65%;">' +
'<table id="tblConWeightingsBU-' + SCWViewModel.ClickedLevelDetailId() + '" ><tbody>';
            for (var i = 0; i < rows; i++) {
                var factText = SCWViewModel.ControlAreaList()[i].ControlAreaName();
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;
                selectedRow = SCWViewModel.ControlAreaList()[i].ControlAreaId();

                code += '<tr id="' + SCWViewModel.ControlAreaList()[i].ControlAreaId() + '">';
                for (var k = 0; k < (j) ; k++) {
                    code += '<td id="' + SCWViewModel.BusinessLevelDetailsList()[k].DetailId() + '"class="tbl-weightings-cell long weightingspadding" style="min-height:42px;height:' + colHeight + 'em !important;"><div class="input-group">';
                    selectedCol = SCWViewModel.BusinessLevelDetailsList()[k].DetailId();
                    if (checkBULevelWeighting == 1) {
                        var check_new = true;
                        for (var val = 0; val < SCWViewModel.WeightingsList().length; val++) {
                            if (SCWViewModel.WeightingsList()[val].ControlAreaId() == SCWViewModel.ControlAreaList()[i].ControlAreaId() && SCWViewModel.WeightingsList()[val].BuId() == SCWViewModel.BusinessLevelDetailsList()[k].DetailId()) {


                                code += '<input type="text" class="form-control form-controlWT"  data-bind="event: {keyup: $root.InputChange}" id="txt_BULweightingCon' + i + '_' + k + '_' + SCWViewModel.ClickedLevelDetailId() + '" value="' + SCWViewModel.WeightingsList()[val].WeightingValue() + '"></input><span class="input-group-addon">%</span>';
                                check_new = false;
                                break;
                            }
                        }
                        if (check_new) {

                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            SCWViewModel.WeightingsList().push(newObj);
                            code += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULweightingCon' + i + '_' + k + '_' + SCWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                        }
                    } else {
                        var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                        SCWViewModel.WeightingsList().push(newObj);
                        code += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULweightingCon' + i + '_' + k + '_' + SCWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                    }
                    code += '</div></td>';

                } code += '</tr>';
            }
            code += '</tbody></table></div>';
            //data end
            //Total  cell

            code += '<div class="wclscscroll corner-header">' +
                '<table>' +
           '<tr>';

            code += '<td  style="min-height:42px;height:5em !important;" class="tbl-weightings-cell weightingspadding label-info">';
            code += "Total"
            code += '</td>' +

            '</tr>' +

         '</table>' +
    '</div>' +
            //Total cell end  
            //Total Data
            '<div class="wclscscroll-footer column-footer" style="overflow-y: hidden!important;background-color:transparent" id="clscroll-column-footer' + SCWViewModel.ClickedLevelDetailId() + '">' +
                 '<table>' +
                     '<tr>';
            for (l = 0; l <= SCWViewModel.BusinessLevelDetailsList().length - 1; l++) {
                code += '<td style="min-height:42px;height:5em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                code += '<input type="text" disabled style="background-color:#cccccc" class="form-control form-controlWT" id="' + 'txt_BULweightingCon' + l + SCWViewModel.ClickedLevelDetailId() + '"></input><span class="input-group-addon">%</span>';
                code += '</td>';
            }
            code += '</tr>' +
    '</table></div>';
            document.getElementById('divAMLControlsWeightings').innerHTML = code;
            ko.applyBindingsToNode($('#btnSANCSave-' + SCWViewModel.ClickedLevelDetailId()), { click: SCWViewModel.saveAMLLevelControlsWeightings }, SCWViewModel);
            ko.applyBindingsToNode($('#btnSANCCopy-' + SCWViewModel.ClickedLevelDetailId()), { click: SCWViewModel.copyOverallData }, SCWViewModel);
            for (var i = 0; i < rows; i++) {
                for (var k = 0; k <= (j + 1) ; k++) {

                    ko.applyBindingsToNode($('#txt_BULweightingCon' + i + '_' + k + '_' + SCWViewModel.ClickedLevelDetailId()), { event: { keyup: SCWViewModel.InputChange } }, SCWViewModel);

                }
            }
            //GetTotalControlWeightingsBUL();
            GetTotalWeightingsOverall();
            ImplementOverallWeightingsSecurity();
            $("#clscroll-content" + SCWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-row-headers" + SCWViewModel.ClickedLevelDetailId()).scrollTop($("#clscroll-content" + SCWViewModel.ClickedLevelDetailId()).scrollTop());
                $("#clscroll-column-headers" + SCWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-content" + SCWViewModel.ClickedLevelDetailId()).scrollLeft());
                $("#clscroll-column-footer" + SCWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-content" + SCWViewModel.ClickedLevelDetailId()).scrollLeft());
            });

            $("#clscroll-column-headers" + SCWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-content" + SCWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-column-headers" + SCWViewModel.ClickedLevelDetailId()).scrollLeft());
            });

            $("#clscroll-column-footer" + SCWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-content" + SCWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-column-footer" + SCWViewModel.ClickedLevelDetailId()).scrollLeft());
            });

            $("#clscroll-row-headers" + SCWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-content" + SCWViewModel.ClickedLevelDetailId()).scrollTop($("#clscroll-row-headers" + SCWViewModel.ClickedLevelDetailId()).scrollTop());
            });
            $('#loadingMainControlsDiv_SANC').hide();
            $('#divAMLControlsWeightings').show();
        }
            else {

                $('#divAMLControlsWeightings').empty();
                $('#divAMLControlsWeightings').addClass('alert-warning-error')
                
                $('#divAMLControlsWeightings').get(0).innerHTML = "There are no Organizational Sub Levels configured for this Organizational Level."
                $('#loadingMainControlsDiv_SANC').hide();
                $('#divAMLControlsWeightings').show();

            }
            $('#loadingMainControlsDiv_SANC').hide();
            $('#RiskAreaTabDiv').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BULevelWeightingsTable() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    }
    function copyOverallData() {
        try {
            $('#loadingMainControlsDiv_SANC').show();
            $('#divAMLControlsWeightings').hide();
            SCWViewModel.CopyDataButtonClicked(true);
            var cols = SCWViewModel.BusinessLevelDetailsList().length;
            $("#lblErrorAMLControls").hide();
            var valid = 0;
            var selectedRowId = 0;
            var selectedColId = 0;
            var wValue = 0;
            var sum = 0;
            var rows;
            var Weightingvalue = [];
            var tableid = 'tblConWeightingsBU-' + SCWViewModel.ClickedLevelDetailId();
            rows = SCWViewModel.ControlAreaList().length;
            for (var i = 0; i < rows; i++) {
                var txtValue = $($($('#' + tableid + ' tbody tr').get(i)).find('td').get(0)).find('input').get(0).value
                if (txtValue == "") {
                    $("#lblErrorAMLControls").show();
                    $("#lblErrorAMLControls").text('Cell cannot be left blank.');
                    valid = 1;
                    break;
                }
                else {
                    var txt = parseFloat(txtValue);
                    if (!$.isNumeric(txt)) {
                        $("#lblErrorAMLControls").show();
                        $("#lblErrorAMLControls").text('Non-numeric entry is not allowed.');
                        valid = 1;
                        break;
                    }
                    else if (txt < 0 || txt > 100) {
                        $("#lblErrorAMLControls").show();
                        $("#lblErrorAMLControls").text('Value should be in range of (0-100).');
                        valid = 1;
                        break;
                    }
                    else {
                        Weightingvalue.push(txt);
                        sum += txt;
                    }
                }
            }
            if (valid == 1) {
                SCWViewModel.ErrorStatus(1);
            }
            if (valid == 0) {
                SCWViewModel.WeightingsList([]);
                for (var i = 0; i < rows; i++) {
                    selectedRowId = SCWViewModel.ControlAreaList()[i].ControlAreaId();
                    for (var j = 0; j < cols; j++) {
                        selectedColId = SCWViewModel.BusinessLevelDetailsList()[j].DetailId();
                        //wValue = $($('#tblAMLControlsWeightings tbody tr').get(i)).find('td').get(1).firstChild.value;
                        wValue = Weightingvalue[i];
                        var newObj = new WeightingModel({ 'Id': selectedRowId, 'BuId': selectedColId, 'WeightingValue': wValue });
                        SCWViewModel.WeightingsList.push(newObj);
                    }
                }
                $('#' + tableid).remove();  //tblAMLControlsWeightings
                $('#innerdiv').remove();
                $('#outerdiv').remove();
                CULevelWeightingsTable(1);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyDataAMLControls() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    }
    function ImplementOverallWeightingsSecurity() {
        try {
            if (SCWViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblConWeightingsBU-' + SCWViewModel.ClickedLevelDetailId() + ' tbody').find('input').length; i++) {
                    $($('#tblConWeightingsBU-' + SCWViewModel.ClickedLevelDetailId() + ' tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ImplementOverallWeightingsSecurity() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    }
    function ImplementSecurity() {
        try {
            if (SCWViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblAMLControlsWeightings tbody').find('input').length; i++) {
                    $($('#tblAMLControlsWeightings tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ImplementSecurity() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    }
    function buildsaveConBULOverallWeightingsList() {
        try {
            SCWViewModel.BULWeightingsListSave([]);
            var rows = SCWViewModel.ControlAreaList().length;
            var cols = SCWViewModel.BusinessUnitsList().length;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_weightingAMLControls' + i + '_' + j;
                    var newObj = new WeightingModel({
                        'Id': SCWViewModel.ControlAreaList()[i].ControlAreaId(), 'BuId': SCWViewModel.BusinessUnitsList()[j].BusinessUnit_ID(),
                        'WeightingValue': $(txtid).val()
                    });
                    SCWViewModel.BULWeightingsListSave().push(newObj);
                }

            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveBULWeightingsList() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }

    }
    function buildsaveConBULWeightingsList() {
        try {
            SCWViewModel.BULWeightingsListSave([]);
            var rows = SCWViewModel.ControlAreaList().length;
            var cols = SCWViewModel.BusinessLevelDetailsList().length;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_BULweightingCon' + i + '_' + j + '_' + SCWViewModel.ClickedLevelDetailId();
                    var newObj = new WeightingModel({
                        'Id': SCWViewModel.ControlAreaList()[i].ControlAreaId(), 'BuId': SCWViewModel.BusinessLevelDetailsList()[j].DetailId(),
                        'WeightingValue': $(txtid).val()
                    });
                    SCWViewModel.BULWeightingsListSave().push(newObj);
                }

            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveBULWeightingsList() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    }
    function saveAMLLevelControlsWeightings(event) {

        try {
            $('#loadingMainControlsDiv_SANC').show();
            $('#RiskAreaTabDiv').hide();
            $("#lblErrorAMLControls-" + SCWViewModel.ClickedLevelDetailId()).hide();
            var colsBUL = SCWViewModel.BusinessLevelDetailsList().length - 1;
            var rows = SCWViewModel.ControlAreaList().length;
            var tableId = '#tblConWeightingsBU-' + SCWViewModel.ClickedLevelDetailId();

            var valid = 1;
            var check = 0;
            for (var i = 0; i <= colsBUL; i++) {
                var sum = 0;

                for (var j = 0; j < rows; j++) {
                    if ($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value == "") {
                        $($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild).val(0);
                    }
                    if (!$.isNumeric($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) {
                        valid = 0;
                        $("#lblErrorAMLControls-" + SCWViewModel.ClickedLevelDetailId()).show();
                        $("#lblErrorAMLControls-" + SCWViewModel.ClickedLevelDetailId()).text('Non-numeric values are not allowed.');
                        check = 1;
                    }
                    else if ($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value < 0 || $($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value > 100) {
                        valid = 0;
                        $("#lblErrorAMLControls-" + SCWViewModel.ClickedLevelDetailId()).show();
                        $("#lblErrorAMLControls-" + SCWViewModel.ClickedLevelDetailId()).text('Value should be in range of (0-100).');
                        check = 1;
                    }
                    else {
                        sum += parseFloat($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value);
                    }
                }
                if (sum != 100 && sum != 0) {
                    if (check == 0) {
                        valid = 0;
                        $("#lblErrorAMLControls-" + SCWViewModel.ClickedLevelDetailId()).show();
                        $("#lblErrorAMLControls-" + SCWViewModel.ClickedLevelDetailId()).text('The total for weightings across control areas should be 100% for organization sublevel ' + SCWViewModel.BusinessLevelDetailsList()[i].DetailName() + '.');
                        break;
                    }
                }
            }
            if (valid == 0) {
                $('#loadingMainControlsDiv_SANC').hide();
                $('#RiskAreaTabDiv').show();
                SCWViewModel.ErrorStatus(1);
            }
            if (valid == 1) {
                try {
                    buildsaveConBULWeightingsList();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/WeightingsThresholds/SaveControlWeightingsBUL?RiskAreaType=SANC&BUL_Entity_ID=" + SCWViewModel.ClickedLevelDetailId(),//to save the bu level wieghtings.
                        headers: headers,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify($.map(SCWViewModel.BULWeightingsListSave(), function (item) {
                            return { Id: item.ControlAreaId(), BuId: item.BuId(), WeightingValue: item.WeightingValue() };
                        }))
                    })
                    .success(ajaxSuccessOverallBU)
                    .fail(ajaxFailOverallBU);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveBULWeightings() method in SanctionsControlsWeightings.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccessOverallBU(jsonResult, status) {
                    try {
                        if (jsonResult != null && jsonResult != 0) {
                            //var mappedData = $.map(jsonResult, function (result) {
                            //    return new WeightingModel(result);
                            //});
                            SCWViewModel.WeightingsList([]);
                            // AOLWViewModel.BULWeightingsList(mappedData);
                            $(tableId).remove();
                            $("#lblErrorAMLControls-" + SCWViewModel.ClickedLevelDetailId()).hide();
                            logger.logSuccess('Sanctions Control Weightings for Business Unit Levels saved successfully.', 'Success', system.getModuleId(SCWViewModel), true);
                            GetCULevelWeightings();
                            $("#lblErrorAMLControls-" + AOLWViewModel.ClickedLevelDetailId()).hide();
                            logger.logSuccess('Overall Inherent Weightings for Business Unit Levels saved successfully.', 'Success', system.getModuleId(AOLWViewModel), true);
                        }
                        else {
                            logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(SCWViewModel), true);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveBULWeightings() method in SanctionsControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFailOverallBU(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveBULWeightings() method in SanctionsControlsWeightings.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveBULWeightings() method in SanctionsControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                }
            }



        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveBULWeightings() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }

    }
    function saveWeightingsAMLControls(event) {
        try {
            $("#lblErrorAMLControls").hide();
            $('#loadingMainControlsDiv_SANC').show();
            $('#RiskAreaTabDiv').hide();
            var cols = SCWViewModel.BusinessUnitsList().length;
            var rows = SCWViewModel.ControlAreaList().length;
            var valid = 1;
            var check = 0;
            for (var i = 0; i < cols; i++) {
                var sum = 0;
                for (var j = 0; j < rows; j++) {
                    if ($($($('#tblAMLControlsWeightings tbody tr').get(j)).find('td').get(i)).find('input').get(0).value == "") {
                        $($($($('#tblAMLControlsWeightings tbody tr').get(j)).find('td').get(i)).find('input').get(0)).val(0);
                    }
                    if (!$.isNumeric($($($('#tblAMLControlsWeightings tbody tr').get(j)).find('td').get(i)).find('input').get(0).value)) {
                        valid = 0;
                        $("#lblErrorAMLControls").show();
                        $("#lblErrorAMLControls").text('Non-numeric values are not allowed');
                        check = 1;
                        break;
                    }
                    else if ($($($('#tblAMLControlsWeightings tbody tr').get(j)).find('td').get(i)).find('input').get(0).value < 0 || $($($('#tblAMLControlsWeightings tbody tr').get(j)).find('td').get(i)).find('input').get(0).value > 100) {
                        valid = 0;
                        $("#lblErrorAMLControls").show();
                        $("#lblErrorAMLControls").text('Value should be in range (0-100)');
                        break;
                    }
                    else {
                        sum += parseFloat($($($('#tblAMLControlsWeightings tbody tr').get(j)).find('td').get(i)).find('input').get(0).value);
                    }
                }
                if (sum != 100 && sum != 0) {
                    if (check == 0) {
                        valid = 0;
                        $("#lblErrorAMLControls").show();
                        $("#lblErrorAMLControls").text('The total for weightings across control areas should be 100% for business unit ' + SCWViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '.');
                        break;
                    }
                }
            }
            if (valid == 0) {
                SCWViewModel.ErrorStatus(1);
                $('#loadingMainControlsDiv_SANC').hide();
                $('#RiskAreaTabDiv').show();
            }
            if (valid == 1) {
                try {
                    if (SCWViewModel.ClickedType().toUpperCase() == "LOWEST") {
                        SCWViewModel.ClickedLevelDetailIdDup(SCWViewModel.ClickedLevelDetailId());
                        SCWViewModel.ClickedLevelDetailId("LLEVEL");
                    }
                    buildsaveConBULOverallWeightingsList();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/WeightingsThresholds/SaveControlWeightingsBUL?RiskAreaType=SANC&BUL_Entity_ID=" + SCWViewModel.ClickedLevelDetailId(),//to save the bu level wieghtings.
                        headers: headers,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify($.map(SCWViewModel.BULWeightingsListSave(), function (item) {
                            return { Id: item.ControlAreaId(), BuId: item.BuId(), WeightingValue: item.WeightingValue() };
                        }))
                    })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveWeightingsAMLControls() method in SanctionsControlsWeightings.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(jsonResult, status) {
                    try {
                        if (SCWViewModel.ClickedType().toUpperCase() == "LOWEST") {
                            SCWViewModel.ClickedLevelDetailId(SCWViewModel.ClickedLevelDetailIdDup());
                        }
                        if (jsonResult != null) {
                            $('#tblAMLControlsWeightings').remove();
                            $('#innerdiv').remove();
                            $('#outerdiv').remove();
                            GetCULevelWeightings();
                            logger.logSuccess('Sanctions Control Weightings saved successfully.', 'Success', system.getModuleId(SCWViewModel), true);
                        }
                        else {
                            logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(SCWViewModel), true);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveWeightingsAMLControls() method in SanctionsControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveWeightingsAMLControls() method in SanctionsControlsWeightings.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveWeightingsAMLControls() method in SanctionsControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveWeightingsAMLControls() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function saveValues(event) {
        try {
            $("#lblErrorAMLControls").hide();
            var selectedRowId = event.currentTarget.parentNode.parentNode.id;
            var selectedColId = $('#tblAMLControlsWeightings').find('th').get($('#tblAMLControlsWeightings').find($(event.currentTarget.parentNode)).index()).id;
            if (event.currentTarget.value == "") {
                event.currentTarget.value = 0;
            }
            else {
                if (!$.isNumeric(event.currentTarget.value)) {
                    $("#lblErrorAMLControls").show();
                    $("#lblErrorAMLControls").text('Non-numeric entry is not allowed.');
                }
                else if (event.currentTarget.value < 0 || event.currentTarget.value > 100) {
                    $("#lblErrorAMLControls").show();
                    $("#lblErrorAMLControls").text('Value should be in range of (0-100).');
                }
                else {
                    for (var i = 0, j = SCWViewModel.WeightingsList().length; i < j; i++) {
                        if (SCWViewModel.WeightingsList()[i].ControlAreaId() == selectedRowId && SCWViewModel.WeightingsList()[i].BuId() == selectedColId) {
                            SCWViewModel.WeightingsList()[i].WeightingValue(parseFloat(event.currentTarget.value));
                        }
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveValues() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function copyDataAMLControls(event) {
        try {
            $('#loadingMainControlsDiv_SANC').show();
            $('#divAMLControlsWeightings').hide();
            SCWViewModel.CopyDataButtonClicked(true);
            var cols = SCWViewModel.BusinessUnitsList().length;
            $("#lblErrorAMLControls").hide();
            var valid = 0;
            var selectedRowId = 0;
            var selectedColId = 0;
            var wValue = 0;
            var sum = 0;
            var rows;
            var weightingsvaluearray = []
            rows = SCWViewModel.ControlAreaList().length;
            for (var i = 0; i < rows; i++) {
                var txtValue = $($($('#tblAMLControlsWeightings tbody tr').get(i)).find('td').get(0)).find('input').get(0).value
                if (txtValue == "") {
                    $("#lblErrorAMLControls").show();
                    $("#lblErrorAMLControls").text('Cell cannot be left blank.');
                    valid = 1;
                    break;
                }
                else {
                    var txt = parseFloat(txtValue);
                    if (!$.isNumeric(txt)) {
                        $("#lblErrorAMLControls").show();
                        $("#lblErrorAMLControls").text('Non-numeric entry is not allowed.');
                        valid = 1;
                        break;
                    }
                    else if (txt < 0 || txt > 100) {
                        $("#lblErrorAMLControls").show();
                        $("#lblErrorAMLControls").text('Value should be in range of (0-100).');
                        valid = 1;
                        break;
                    }
                    else {
                        weightingsvaluearray.push(txt);
                        sum += txt;
                    }
                }
            }
            if (valid == 1) {
                SCWViewModel.ErrorStatus(1);
            }
            if (valid == 0) {
                SCWViewModel.WeightingsList([]);
                for (var i = 0; i < rows; i++) {
                    selectedRowId = SCWViewModel.ControlAreaList()[i].ControlAreaId();
                    for (var j = 0; j < cols; j++) {
                        selectedColId = SCWViewModel.BusinessUnitsList()[j].BusinessUnit_ID();
                        //wValue = $($('#tblAMLControlsWeightings tbody tr').get(i)).find('td').get(1).firstChild.value;
                        wValue = weightingsvaluearray[i];
                        var newObj = new WeightingModel({ 'Id': selectedRowId, 'BuId': selectedColId, 'WeightingValue': wValue });
                        SCWViewModel.WeightingsList.push(newObj);
                    }
                }
                $('#tblAMLControlsWeightings').remove();  //tblAMLControlsWeightings
                $('#innerdiv').remove();
                $('#outerdiv').remove();
                WeightingsTable(1);
                GetTotalWeightings();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyDataAMLControls() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    //-------------------------------------------------------------------Model Definition Starts Here----------------------------------------------------------------------------

    function BusinessUnits(item) {
        try {
            var self = this;
            self.BusinessUnit_ID = ko.observable(item.BuId);
            self.BusinessUnit_Name = ko.observable($('<div/>').html(item.BuName).text());
            self.BuAssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
            self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
            self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnits() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    }

    function ControlAreas(item) {
        try {
            var self = this;
            self.ControlAreaId = ko.observable(item.ControlAreaId);
            self.ControlAreaName = ko.observable($('<div/>').html(item.ControlAreaName).text()); 
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlAreas() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    }
    function BusinessLevelModel(item) {
        try {
            var self = this;
            self.Bulevel = ko.observable($('<div/>').html(item.BuLId).text());
            self.BlName = ko.observable($('<div/>').html(item.BuLevelName).text());
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    }
    function BusinessLevelDetail(item) {
        try {
            var self = this;
            self.DetailId = ko.observable($('<div/>').html(item.BuLevelDetailId).text());
            self.DetailName = ko.observable($('<div/>').html(item.BuLevelDetailName).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelDetail() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    };
    function WeightingModel(item) {
        try {
            var self = this;
            self.ControlAreaId = ko.observable(item.Id);
            self.BuId = ko.observable(item.BuId);
            self.WeightingValue = ko.observable(item.WeightingValue);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: WeightingModel() method in SanctionsControlsWeightings.js';
            logger.logMessage(msg);
        }
    }
    //-------------------------------------------------------------------Model Definition Ends Here----------------------------------------------------------------------------
});
